import { http } from '@4beefopag/4bee-fopag-core/dist/services';

export const buscar = async () => {
  const { data } = await http.get('/notificacao');
  return data;
};

export const getAll = async () => {
  const { data } = await http.get('/notificacao/todas');
  return data;
};

export const removeById = async (id) => {
  const { data } = await http.delete(`/notificacao/${id}`);
  return data;
};

export const restoreById = async (id) => {
  const { data } = await http.post(`/notificacao/${id}/restaurar`);
  return data;
};

export const create = async (body) => {
  const { data } = await http.post(`/notificacao`, body);
  return data;
};

export const confirmarLeitura = async (id) => http.post(`/notificacao/${id}/salvar`);
